import { isNumber, isString, isUndefinedOrNull } from "@omnia/shared/utils/utils"
import { camelCaseKeys } from "../case"
import { ResourceMetadata, ResourceOwner, ResourceWithMetadata } from "./types"

export function getOwnerFromResource(arg: ResourceWithMetadata) {


}


export function isResourceOwner(arg: {}): arg is ResourceOwner {
    return arg && Boolean(arg["userId"])
}


/**
 * Exracts a owner id from various types of arguments
 */
export function getOwnerId(arg: ResourceWithMetadata | number | string | ResourceOwner) {

    if (isUndefinedOrNull(arg)) {
        return ""
    }

    if (isString(arg)) {
        return arg
    }

    if (isNumber(arg)) {
        return String(arg)
    }

    if (isResourceOwner(arg)) {
        return arg.userId
    }

    if (isPascalCasedResourceWithMetadata(arg)) {
        arg = camelCaseKeys(arg)
    }

    if (arg.metadata?.owner) {
        return arg.metadata.owner.userId
    }

    if (arg.createdBy) {
        return String(arg.createdBy)
    }

}

function isPascalCasedResourceWithMetadata(arg: {}): arg is Extract<ResourceWithMetadata, { Metadata: ResourceMetadata }> {
    return arg && (
            ("CreatedBy" in arg)
        ||  ("Metadata" in arg)
    )
}
